var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',{staticClass:"mt-4",attrs:{"rules":[_vm.rules.name],"label":"Neuer Name","placeholder":"neuer name","type":"name","autocomplete":"new-name","loading":_vm.name.length < 0},on:{"input":_vm.inputChanged},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }